var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CloHeading',{staticClass:"u-stack-sm",attrs:{"level":"3","size":"4","href":_vm.prefix + _vm.href,"reverse":"","hiddenLink":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }